import { MessageCircle, Phone, MapPin } from "lucide-react";
import { Reveal } from "./Shared";
import { waLink, telLink } from "@/lib/api";

export default function FinalCTA({ settings }) {
  return (
    <section data-testid="final-cta-section" className="border-t border-border bg-white py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-muted-foreground">¿Buscas un electrodoméstico?</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 data-testid="final-cta-title" className="mt-4 max-w-3xl text-4xl font-extrabold tracking-tighter text-primary sm:text-5xl lg:text-6xl">
            Nuestro equipo está listo para ayudarte.
          </h2>
        </Reveal>
        <Reveal delay={0.16} className="mt-10 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
          <a
            data-testid="final-whatsapp-cta"
            href={waLink(settings, "Hola Electrodomésticos Rivera, busco un electrodoméstico y quiero que me ayuden.")}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex h-14 items-center justify-center gap-2 rounded-full bg-whatsapp px-8 text-base font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5"
          >
            <MessageCircle className="h-5 w-5" /> WhatsApp
          </a>
          <a
            data-testid="final-call-cta"
            href={telLink(settings)}
            className="inline-flex h-14 items-center justify-center gap-2 rounded-full border-2 border-primary px-8 text-base font-semibold text-primary transition-colors duration-300 hover:bg-primary hover:text-white"
          >
            <Phone className="h-5 w-5" /> Llamar {settings.phone_display || ""}
          </a>
          <a
            data-testid="final-visit-cta"
            href="#ubicaciones"
            className="inline-flex h-14 items-center justify-center gap-2 rounded-full border-2 border-primary/20 px-8 text-base font-semibold text-primary transition-colors duration-300 hover:border-primary"
          >
            <MapPin className="h-5 w-5" /> Visitar tienda
          </a>
        </Reveal>
      </div>
    </section>
  );
}
